import { FC, useCallback, useEffect, useState } from "react";

import {
  PIE_CHART_OPTIONS,
} from "src/constants/highCharts";
import { StatisticsObjectType } from "../caseVolume/types";
import { wrapperFunctionPieChart } from "src/helpers";
import CustomPieChart from "../customPieChart";



const Top10Payors: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [topPayor, setTopPayor] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [caseBySubmission, setCaseBySubmission] = useState({});



  const populateTopPayorPieChart = useCallback(() => {
    const topPayorOptions = {
      ...PIE_CHART_OPTIONS,
      series: wrapperFunctionPieChart(StatisticsObjectType?.top_payors)
    };
    setTopPayor(topPayorOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [StatisticsObjectType]);

  useEffect(() => {
    populateTopPayorPieChart();
  }, [populateTopPayorPieChart]);




  const populateCaseBySubmissionPieChart = useCallback(() => {
    const caseBySubmissionOptions = {
      ...PIE_CHART_OPTIONS,
      series: wrapperFunctionPieChart(StatisticsObjectType?.mos)
    };
    setCaseBySubmission(caseBySubmissionOptions);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [StatisticsObjectType]);

  useEffect(() => {
    populateCaseBySubmissionPieChart();
  }, [populateCaseBySubmissionPieChart]);



  return (
    <div className="row">
    <div className="col-12 col-sm-12 col-md-6">
      <CustomPieChart title={'Top 10 Payors'} pieChartObject={StatisticsObjectType?.top_payors} />
    </div>
    <div className="col-12 col-sm-12 col-md-6">
      <CustomPieChart title={'Cases By Submission Mode'} pieChartObject={StatisticsObjectType?.mos} />
    </div>
  </div>
  );
};

export default Top10Payors;
